import { render, staticRenderFns } from "./ReportMaterialsMountings.vue?vue&type=template&id=93ca70b0&scoped=true&"
import script from "./ReportMaterialsMountings.vue?vue&type=script&lang=js&"
export * from "./ReportMaterialsMountings.vue?vue&type=script&lang=js&"
import style0 from "./ReportMaterialsMountings.vue?vue&type=style&index=0&id=93ca70b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ca70b0",
  null
  
)

export default component.exports
import {QBtn,QInput,QCheckbox} from 'quasar'
component.options.components = Object.assign({QBtn,QInput,QCheckbox}, component.options.components || {})
